<template>
<!-- <div > -->
  <v-container grid-list-md fluid>
    <!-- <pre>{{chartData}}</pre> -->
    <!-- Botonera -->
    <v-layout column bottom right floating fixed class="fab-container">
      <v-tooltip left>
        <v-btn @click="openModalEjecucion()" icon small dark fab  color="accent" slot="activator">
          <v-icon >mdi-calendar-clock</v-icon>
        </v-btn>
        <span>{{$t('view.seguimientoControl.execProcess')}}</span>
      </v-tooltip>
      <v-menu v-model="view.elem.form.show" left :close-on-content-click="false" >
        <v-tooltip slot="activator" left>
          <v-btn icon small dark fab  color="teal darken-2" slot="activator" >
            <v-icon >mdi-filter</v-icon>
          </v-btn>
          <span>Filtros</span>
        </v-tooltip>
        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-avatar color="indigo">
                  <v-icon dark>mdi-filter</v-icon>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{$t("view.global.common.filtros")}}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon @click="submit()" >
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-combobox 
                  :label="$t('view.global.common.filtro')"
                  :max-height="200" 
                  item-text="name"
                  item-value="code"
                  v-model="view.elem.filters.selectedOptionFilter"
                  :items="view.elem.filters.options"
                  multiple
                  dense   
                  clearable
                  deletable-chips                           
                  small-chips>
                </v-combobox>
              </v-list-tile-action>
              <!-- <v-list-tile-title></v-list-tile-title> -->
            </v-list-tile>
            <v-divider/>
            <v-flex md12  v-show="valueFilters['Fecha'] != null">
              <v-list-tile>
                <v-list-tile-action>
                  <v-menu ref="dialogFecha" :close-on-content-click="false" v-model="view.elem.filters.modalFecha" :nudge-right="40"
                    :return-value.sync="$v.seguimientoControl.fecha.$model"  transition="scale-transition" offset-y
                    full-width min-width="290px" >
                    <v-text-field
                      slot="activator"
                      v-model="formatFechaInicio"
                      :error-messages = "$t(`validator.${getFirstError($v.seguimientoControl.fecha)}.text`,'')"
                      :label="$t('view.global.common.fechaHasta')"
                      prepend-icon="event"
                      readonly>
                    </v-text-field>
                    <v-date-picker  @input="$refs.dialogFecha.save($v.seguimientoControl.fecha.$model)"
                      locale="es-ES" v-model="$v.seguimientoControl.fecha.$model">
                    </v-date-picker>
                  </v-menu>
                </v-list-tile-action>
                <!-- <v-list-tile-title>Enable hints</v-list-tile-title> -->
              </v-list-tile>
              <v-divider/>
            </v-flex>
            <v-flex md12  v-show="valueFilters['Proceso'] != null">
              <v-list-tile >
                <v-list-tile-action>
                  <v-combobox 
                    :label="$t('view.global.common.proceso')"
                    :max-height="200" 
                    item-text="name"
                    item-value="code"
                    v-model="$v.seguimientoControl.tipoProceso.$model"
                    :items="view.elem.select.procesos.options"
                    dense   
                    clearable
                    deletable-chips                           
                    small-chips>
                  </v-combobox>
                </v-list-tile-action>
                <!-- <v-list-tile-title>Enable hints</v-list-tile-title> -->
              </v-list-tile>
              <v-divider/>
            </v-flex>
            <v-flex md12  v-show="valueFilters['Ejecucion'] != null">
              <v-list-tile >
                <v-list-tile-action>
                  <v-combobox 
                    :label="$t('view.seguimientoControl.tipoEjecucion')"
                    :max-height="200" 
                    item-text="name"
                    item-value="code"
                    v-model="$v.seguimientoControl.tipoEjecucion.$model"
                    :items="view.elem.select.tipoEjecucion.options"
                    dense   
                    clearable
                    deletable-chips                           
                    small-chips>
                  </v-combobox>
                </v-list-tile-action>
                <!-- <v-list-tile-title>Enable hints</v-list-tile-title> -->
              </v-list-tile>
              <v-divider/>
            </v-flex>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="submit()">{{$t("view.global.common.aplicar")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-layout>
    <!-- Fin Botonera -->
    <!-- Grafica -->
    <v-layout child-flex wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar dense primary-title  tile>
            <v-toolbar-title>{{$t("view.global.common.chart")}}</v-toolbar-title>
            <v-chip 
            small 
            :key="filter.name" 
            v-for="filter in view.elem.filters.selectedOptionFilter" >
              <v-avatar class=" white--text" :color="valueFilters[filter.name].color != undefined ? valueFilters[filter.name].color : 'primary'">
                <v-icon>{{ valueFilters[filter.name].icon }}</v-icon>
              </v-avatar>
              {{ valueFilters[filter.name].value }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.chart.show = !view.elem.chart.show">
              <v-icon>{{ view.elem.chart.show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-toolbar >
          <v-slide-y-transition>
            <div v-show="view.elem.chart.show">
              <v-card-text>
                <v-layout row>
                  <v-flex d-flex md12  v-show="view.elem.chart.showMessage">
                  <v-alert slot="no-results" :value="view.elem.chart.showMessage" color="warning" icon="warning">
                    {{$t('view.global.common.no-data-text')}} 
                  </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row v-show="!view.elem.chart.showMessage">
                  <v-flex d-flex md12 style="height:70vh;">
                    <chartist
                      type="Line"
                      :data="chartData"
                      :options="chartOptions" 
                      :event-handlers="eventHandlers"
                      >
                    </chartist>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </div>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Fin Grafica -->
    <!-- DataTable -->
    <v-layout child-flex wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar dense primary-title  tile>
            <v-toolbar-title>{{$t('view.perfil.registros.label')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.table.show = !view.elem.table.show">
              <v-icon>{{ view.elem.table.show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title v-show="view.elem.table.show">
            <v-spacer></v-spacer>
              <v-text-field
                v-model="view.elem.table.search"
                append-icon="search"
                :label="$t('view.global.common.buscar')"
                single-line
                hide-details
              ></v-text-field>
          </v-card-title>
          <v-slide-y-transition >
            <v-card-text v-show="view.elem.table.show">
              <v-data-table
                :headers="view.elem.table.headers"
                :items="view.elem.table.data"
                :pagination.sync="view.elem.table.pagination"
                :custom-sort="customSort"
                :search="view.elem.table.search" >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.fechaInicio|filterFechaInicio }}</td>
                  <td class="text-xs-center"> 
                    <v-tooltip left> 
                      <v-btn flat icon color="primary" slot="activator" @click="getLog(props.item.proceso)">
                        <v-icon  >{{getIconProccess( props.item.proceso)}} </v-icon>
                      </v-btn>
                      <span> {{props.item.proceso}}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-center">
                    <v-tooltip  left>
                      <v-icon slot="activator" color="primary">
                        {{ getIconTypeExec(props.item.tipoEjecucion) }}
                      </v-icon>
                      <span> {{props.item.tipoEjecucion}}</span>
                    </v-tooltip  >
                  </td>
                  <td class="text-xs-center">
                    <v-tooltip  left>
                      <v-icon slot="activator" color="primary">
                        {{(props.item.interfaz ==="SCHEDULED") ? 'mdi mdi-calendar-clock': 'mdi mdi-sync-alert'}}
                      </v-icon>
                      <span> {{props.item.interfaz != undefined ? props.item.interfaz : "SCHEDULED" }}</span>
                    </v-tooltip  >
                  </td>
                  <td class="justify-center layout px-0">
                    <v-tooltip  left v-if="props.item.detalle">
                      <v-btn slot="activator" color="primary"  icon small dark fab @click="openModalDetalle(props.item.detalle)">
                        <v-icon> search </v-icon>
                      </v-btn>
                      <span> {{$t("view.comercio.detalle")}}</span>
                    </v-tooltip>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  {{$t('view.global.common.no-data-text')}} "{{ view.elem.table.search }}" 
                </v-alert>
                <v-alert slot="no-data" :value="true" color="warning" icon="warning">
                  {{$t('view.global.common.no-data-text')}}
                </v-alert>
              </v-data-table>
            </v-card-text>
          </v-slide-y-transition>
          
          
        </v-card>
      </v-flex>
    </v-layout>
    <!-- DataTable -->
    <!-- detalle de registro  -->
    <modal-detalle ref="modalDetalle"></modal-detalle>
    <!-- detalle de registro  -->
    <!-- Ejecucion Extemporanea -->
    <modal-ejecucion ref="modalEjecucion"></modal-ejecucion>
    <!-- Ejecucion Extemporanea -->
  </v-container>
<!-- </div> -->
</template>
<script>

	import Chartist from 'chartist';
  import moment from 'moment';
  import {allValidatorMethods} from "@/helpers/vuelidate";
  import * as dateMethods from "@/helpers/date-methods";
  import SeguimientoStates from "@/views/seguimiento/scheduled/seguimiento-control-scheduled-states"
  import {required, maxLength,email,numeric} from "vuelidate/lib/validators";
  import ModalDetalle from "@/views/seguimiento/scheduled/ModalDetalleSeguimiento";
  import ModalEjecucion from "@/views/seguimiento/scheduled/EjecucionExtemporanea";
	let seq= 0;
	export default {
    name: "SeguimientoControlScheduled",
    head:{
      title:function(){
        return {
          inner       : this.view.title
          , separator : '|'
          , complement: this.$t("view.home.system.initials")
        }
      }
    }
    , data(){
      let _locale = this.$store.language;
			return{
        locale: _locale
        , seguimientoControl: undefined
        , parametros: undefined
        , form: {}
				, view:{
					titleHeading: this.$t("view.seguimientoControl.scheduled.title") 
          , title: this.$t("view.seguimientoControl.scheduled.title") 
          , action : {
            submit:{
              busy:false
            }
            , privileges:{
              busy:false
            }
          }
					, elem:{
						form:{
              show: false
              , showAll: false
						}
						, chart:{
              show:true
              , showMessage: false
            }
            , dial:{
              show: true
            }
            ,filters:{
              options:[{name:'Fecha',code:'1'},{name:'Proceso', code:'2'},{name:'Ejecucion', code:'3'}]
              , modalFecha: false
              , selectedOptionFilter:[{ "name": "Fecha", "code": "1" }]
            }
            , select:{
              procesos:{
                options:[{name:'Downloader',code:'DOWNLOADER'},{name:'Converter', code:'CONVERTER'},{name:'Uploader', code:'UPLOADER'}]
              }
              , tipoEjecucion:{
                options:[{name:'Petición', code:'PETICION'},{name:'Respuesta', code:'RESPUESTA'}]
              }
            }
            , table:{
              search:''
              , show: true
              , pagination: {
                sortBy: 'fechaInicio'
                , descending: true
              }
              , data:[]
              , headers: [
                {
                  text: this.$t('view.global.common.fecha'),
                  align: 'left',
                  sortable: true,
                  value: 'fechaInicio'
                },
                {
                  text: 'Proceso',
                  align: 'center',
                  sortable: true,
                  value: 'proceso'
                },
                {
                  text: 'Método de llamado',
                  align: 'center',
                  sortable: true,
                  value: 'interfaz'
                },
                {
                  text: 'Ejecución',
                  align: 'center',
                  sortable: true,
                  value: 'tipoEjecucion'
                },
                {
                  text: 'Acciones',
                  align: 'center',
                  sortable: false,
                  value: 'detalle'
                },
              ]
            }

          }
          , tools:{
            dateMethods:dateMethods
          }
				}
				, chartData: {
					labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
          ,series: [
            {
              name: 'Downloader',
              className: 'downloader-petition',
              data: []
            }
            ,{
              name: 'Converter',
              data: []
            }
          ]
        }
        , chartOptions: {
						plugins: [
              Chartist.plugins.tooltip({
                anchorToPoint: true
                , appendToBody: true
                , tooltipFnc: (index, data, meta) => {
                  let value = data.split(",");
                  const tooltipDateFormat = 'DD-MMM-YYYY hh:mm:ss'
                  let tooltip = index.split(",");
                  let contentTooltip = ''
                  for (let i = 0; i < tooltip.length; i++) { 
                      contentTooltip += `${tooltip[i]}</br>`;
                  }
                    return `
                        <div style='padding: 5px 8px;'>
                            ${contentTooltip}
                        </div>
                    `;
                }
              })
            ]
						, fullWidth: true
            , showLine: false
            // , referenceValue: 5
            // , stretch: true
						, axisY: {
              offset:80
              , type: Chartist.AutoScaleAxis
              // , onlyInteger: true
							, labelInterpolationFnc: function(value) {
                return moment(value).format('hh:mm a');
							}
						}
						, axisX: {
							type: Chartist.AutoScaleAxis
              // , divisor: 30
              // , onlyInteger: true
							, labelInterpolationFnc: function(value) {
								return moment(value).format('MMM D');
							}
            }
            // , width: 980
            // , height: 400
				}
				,eventHandlers : [
					// {
					// 	event: 'created',
					// 	fn(data) {
					// 		seq =0;
					// 	}
					// }
					// , {
					// 	event: 'draw',
					// 	fn(data) {
					// 		if(data.type === 'point') {
          //       // let circle = new Chartist.Svg('circle', {
          //       //   cx: [data.x], cy:[data.y], r:[5],
          //       // }, 'ct-circle');
          //       // data.element.replace(circle);
					// 			data.element.animate({
					// 				opacity: {
					// 					// The delay when we like to start the animation
					// 					begin: seq++ * 80,
					// 					// Duration of the animation
					// 					dur: 50,
					// 					// The value where the animation should start
					// 					from: 0,
					// 					// The value where it should end
					// 					to: 1
					// 				},
					// 				x1: {
					// 					begin: seq++ * 80,
					// 					dur: 500,
					// 					from: data.x - 100,
					// 					to: data.x,
					// 					// You can specify an easing function name or use easing functions from Chartist.Svg.Easing directly
					// 					easing: Chartist.Svg.Easing.easeOutQuart
					// 				}
					// 			});
					// 		}
					// 	}
					// }
				]
			}
    }
    , methods: {
      ...allValidatorMethods
      , async submit(){
        try{        
          const respuesta = await this.form.$state.submit(this.seguimientoControl);
          this.view.elem.form.show = !this.view.elem.form.show;
        }catch(error){
          console.log(error);
        }
      }
      , async getLog(proceso){
        try{        
          await this.form.$state.getLog(proceso);
          
        }catch(error){
          console.log(error);
        }
      }
      , getIconProccess(proceso){
        if(proceso === "DOWNLOADER")
          return ' mdi mdi-cloud-download mdi-24px'
        if(proceso === "CONVERTER")
          return ' mdi mdi-atom mdi-24px'
        if(proceso=== "UPLOADER")
          return ' mdi mdi-cloud-upload mdi-24px'
          
      }
      , customSort(items, index, isDesc) {
        
        items.sort((a, b) => {
          
          if (index === 'fechaInicio') {
            if (isDesc) {
              return new Date(b[index]) - new Date(a[index]);
            } else {
              return new Date(a[index]) - new Date(b[index]);
            }
          } else {
            if (!isDesc) {
              return a[index] < b[index] ? -1 : 1;
            } else {
              return b[index] < a[index] ? -1 : 1;
            }
          }
        });
        return items;
      }
      , getIconTypeExec(tipoEjecucion){
        if(tipoEjecucion=== "PETICION")
          return ' mdi mdi-file-send mdi-24px'
        if(tipoEjecucion=== "RESPUESTA")
          return ' mdi mdi-file-undo mdi-24px'
          
      }
      , openModalDetalle(detalle){
        this.$refs.modalDetalle.dialog = true;
        this.$refs.modalDetalle.detalleBitacora = detalle;
      }
      , openModalEjecucion(){
        this.$refs.modalEjecucion.openModal();
      }

    }
    , computed:{
      formatFechaInicio(){
        return dateMethods.formatDate(this.$v.seguimientoControl.fecha.$model);
      }
      , valueFilters(){
        let response = {};
        for (let filter of this.view.elem.filters.selectedOptionFilter) {
          if(filter.code == 1){
            response [filter.name] = {icon:'event', name:filter.name ,value: this.formatFechaInicio};
          }

          if(filter.code == 2 ){
            response [filter.name] = {icon:'history',name:filter.name ,value: (this.seguimientoControl.tipoProceso != undefined ? this.seguimientoControl.tipoProceso.code :'' )};
          }

          if(filter.code == 3 ){
            let color = (this.seguimientoControl.tipoEjecucion != undefined ? this.seguimientoControl.tipoEjecucion.code :'')
            if (color === 'RESPUESTA'){
              color = 'green'              
            }else{
              color = 'primary'
            }

            response [filter.name] = {color: color ,icon:'mdi-bullseye-arrow',name:filter.name ,value: (this.seguimientoControl.tipoEjecucion != undefined ? this.seguimientoControl.tipoEjecucion.code :'')};
          }
        
        }
        
        return response;
      }
    }
    , validations:{
      seguimientoControl:{
        fecha:{
          required
        }
        , tipoProceso:{

        }
        , tipoEjecucion:{

        }
      }
    }
    , components: {
      ModalDetalle
      , ModalEjecucion
    }
    , filters:{
      filterFechaInicio:(fecha)=>{
        return dateMethods.formatDateTime(fecha)
      }
    }
    , created(){
      try{
        this.form = new SeguimientoStates(this);
        this.form.$setState('initial');
        this.form.$state.submit(this.seguimientoControl);        
      }catch(e){

      }
    }
	}
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  #menu .v-speed-dial {
    position: absolute;
  }

  #menu .v-btn--floating {
    position: relative;
    z-index: 9999;
  }

  #lateral .v-speed-dial,
  #lateral .v-btn--floating {
    position: absolute;
  }

  .fab-container {
    position: fixed;
    top: 64px;
    right: 12px;
    z-index: 4;
  }

   .DOWNLOADER-PETICION{
    stroke: #90CAF9;
  }

  .UPLOADER-PETICION{
    stroke: #3949AB;
  }

  .CONVERTER-PETICION{
    stroke: #1E88E5;
  }

  .DOWNLOADER-EXTEMPORANEA{
    stroke: #F44336;
  }

  .DOWNLOADER-RESPUESTA{
    stroke: #CDDC39;
  }

  .UPLOADER-RESPUESTA{
    stroke: #4CAF50;
  }

  .CONVERTER-RESPUESTA{
    stroke: #8BC34A;
  }

  .ct-circle {
    fill: #00805f;
    stroke-width:2;
  }
                                                                                                      

</style>



// WEBPACK FOOTER //
// src/views/seguimiento/scheduled/SeguimientoControlScheduled.vue